import {
  Typography as MuiTypography,
  Divider as MuiDivider,
  useTheme
} from '@mui/material';
import {
  SMuiBox,
  SContainer,
  SContent,
  SHeader,
} from './components/DisplayContainer';

import {
  convertFromJsonOrReturnValue,
  isJson,
} from 'lib/utils/WYSIWYGEditorHelper';
import { newQuestionTypes } from 'lib/enums/questionTypes';
import GetQuestionType from 'lib/utils/getQuestionType';
import { stateToHTML } from 'draft-js-export-html';
import { useTranslation } from 'react-i18next';
import OpenTextDisplay from './components/OpenTextDisplay';
import ChoiceDisplay from './components/ChoiceDisplay';
import RatingDisplay from './components/RatingDisplay';
import FileDisplay from './components/FileDisplay';
import LikertDisplay from './components/LikertDisplay';
import DateDisplay from './components/DateDisplay';
import MediaDisplay from './components/MeidaDisplay';
import TimeDisplay from './components/TimeDisplay'
import { isClockTime } from 'lib/utils/units'

const GetContent = (response, state, question) => {
  if (state?.status !== 'ANSWERED')
    return <OpenTextDisplay value="Not answered" />;

  switch (response?.questionType.toLowerCase()) {
    case newQuestionTypes.openQuestion.toLowerCase():
      return <OpenTextDisplay value={response?.value} />;

    case newQuestionTypes.choice.toLowerCase():
    case newQuestionTypes.multipleChoice.toLowerCase():
    case newQuestionTypes.singleChoice.toLowerCase():
      return (
        <ChoiceDisplay listOfAnswers={response?.listOfAnswerOptionValue} />
      );

    case newQuestionTypes.fileUpload.toLowerCase():
      return <FileDisplay value={'thisisatestfile.pdf'} />;

    case newQuestionTypes.numeric.toLowerCase():
      const unitCode = response?.metric?.components?.[0]?.quantityValue?.code;
      if (isClockTime(unitCode)) {
        return <TimeDisplay value={response?.decimalValue} />;
      }
      else {
        return <OpenTextDisplay value={response?.decimalValue} />;
      }

    case newQuestionTypes.scale.toLowerCase():
    case newQuestionTypes.nps.toLowerCase():
      return <OpenTextDisplay value={response?.intValue?.toString()} />;

    case newQuestionTypes.rating.toLowerCase():
      return <RatingDisplay value={response?.intValue} />;

    case newQuestionTypes.likert.toLowerCase():
      return <LikertDisplay value={response?.answers} question={question} />;

    case newQuestionTypes.date.toLowerCase():
      return (
        <DateDisplay
          value={response?.datetimeValue || response?.valueCognitiveTest}
          includeTime={question?.includeTime}
        />
      );

    case newQuestionTypes.media.toLowerCase():
      return <MediaDisplay question={question} />;

    default:
      return <OpenTextDisplay value="TEST" />;
  }
};
const QuestionnaireDialogItem = ({ state, response, index, question, displayIndex = true }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <SMuiBox
      sx={{
        backgroundColor: theme.palette.colors.gray100,
      }}
    >
      <SContainer>
        <SHeader>
          <MuiTypography fontSize={13}>
            {displayIndex ? `Q${index + 1} - ${t(GetQuestionType(question?.questionType))}` : t(GetQuestionType(question?.questionType))}
          </MuiTypography>
          <MuiTypography fontSize={13}>
            {response
              ? response?.score
                ? `${t('Score')}: ${response?.score}`
                : ''
              : t('Skipped')}
          </MuiTypography>
        </SHeader>
        {response ? (
          <>
            {isJson(response?.questionText) ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: stateToHTML(
                    convertFromJsonOrReturnValue(response?.questionText)
                  ),
                }}
              />
            ) : (
              <div>{response?.questionText}</div>
            )}
            <SContent>{GetContent(response, state, question)}</SContent>
          </>
        ) : null}
      </SContainer>
    </SMuiBox>
  );
};

export default QuestionnaireDialogItem;
